import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EActiveView } from '../../types/view';
import { ERegisterOrAuthStatus } from '../../types/phoneAuth';
import { ERequestStatus } from '../../types/requestStatus';
import { PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE, PHONE_AUTH_SEND_CODE_TYPE } from '../../constants/action_types';
import { changeView } from '../view';
import { sendCode as sendCodeApi, ESendCodeStatus, ESenderType } from '../../api/sendCode';
export function sendCode() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, activeView, phone, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), activeView = _getState.view.active, phone = _getState.phoneAuth.phone;
            dispatch({
              status: ERequestStatus.Loading,
              type: PHONE_AUTH_SEND_CODE_TYPE
            });

            // сбрасываем ошибки авторизации по телефонному коду
            dispatch({
              status: ERegisterOrAuthStatus.Initial,
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
            });
            _context.next = 5;
            return sendCodeApi(context, phone);
          case 5:
            result = _context.sent;
            if (result.status === ESendCodeStatus.Succeed) {
              dispatch({
                status: ERequestStatus.Succeed,
                type: PHONE_AUTH_SEND_CODE_TYPE,
                senderType: result.senderType,
                secondsToRetry: result.secondsToRetry,
                timeStamp: result.timeStamp
              });
              if (result.senderType === ESenderType.Sms && activeView !== EActiveView.PhoneAuthValidateSms) {
                dispatch(changeView(EActiveView.PhoneAuthValidateSms));
              }
              if (result.senderType === ESenderType.Call && activeView !== EActiveView.PhoneAuthValidateCall) {
                dispatch(changeView(EActiveView.PhoneAuthValidateCall));
              }
            } else {
              dispatch(changeView(EActiveView.PhoneAuth));
              dispatch({
                status: ERequestStatus.Failed,
                type: PHONE_AUTH_SEND_CODE_TYPE,
                error: result.message
              });
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}